import React, { useState, useEffect } from 'react';
import '../../css/listDeduction.css';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import moment from 'moment';
import 'moment/locale/pt';
import useCodes from '../../hooks/useCodes';
import PlaceholderLoading from 'react-placeholder-loading';
import { GoDotFill } from "react-icons/go";
import { FaAngleRight } from "react-icons/fa6";
import CustomModalSpendDetail from './CustomModalSpendDetail';
import CustomDrawerSpendDetail from './CustomDrawerSpendDetail';
import { IoMdInformationCircleOutline } from "react-icons/io";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import ListPagination from '../../components/ListPagination';

function ListDeduction(props) {

    const {
        listRespData,
        numPage,
        pageNumber,
        setPageSelected
    } = props;

    const [isLoading, setIsLoading] = useState(true);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const { deducaoStatusList, getDeducaoStatus } = useCodes();
    const [openMovementsInfoModal, setOpenMovementsInfoModal] = useState(false);
    const [isPressedItem, setIsPressedItem] = useState(false)

    useEffect(() => {
        const delay = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(delay);
    }, []);

    const handleClickOpenInfoDataModal = (item) => {
        setIsPressedItem(item)
        setOpenMovementsInfoModal(true)
    };

    const renderDeducaoStatusListByItem = (item) => {
        const deducaoStatus = getDeducaoStatus(item.estado);
        return deducaoStatus;
    };

    return (
        <>
            <div className={isTablet ? ( listRespData.length > 1 ? 'mainOptionsSecondColumnViewContainerListDeduction' : 'mainOptionsSecondOneColumnViewContainerListDeduction') : 'mainOptionsSecondColumnViewContainerListDeductionMobile'}>
                {listRespData?.map((item, index) => (
                    <div className='mainBoxContentContainerListDeduction' key={index}>
                        {isLoading ? <PlaceholderLoading shape="rect" width={350} height={50} /> : (
                            <>
                                <div className={isTablet ? 'mainDataBigBoxViewContainerListDeduction' : 'mainDataBigBoxViewContainerListDeductionMobile'}>
                                    <div className={isTablet ? 'mainDataBoxViewContainerListDeduction' : 'mainDataBoxViewContainerListDeductionMobile'}>
                                        <div className='rowDataBoxViewContainerListDeduction'>
                                            <div className="btnViewOpenInfoDataModalIconListDeduction">{moment(item.dataCriacao).format('LL')}</div>
                                            <div className="personIconViewListDeduction">
                                                <button className='btnViewContainerOpenInfoDataModalIconListDeduction' type='button' onClick={() => handleClickOpenInfoDataModal(item)}>
                                                    <div className='txtOpenInfoDataModalIconListDeduction'>Ver detalhes</div>
                                                    <FaAngleRight className='openInfoDataModalIconListDeduction' />
                                                </button>
                                                    <CustomModalSpendDetail
                                                        apoliceTitle={item.apolice}
                                                        date={moment(item.dataCativo).format('L')}
                                                        nib={item.nib}
                                                        show={isPressedItem === item ? openMovementsInfoModal : null}
                                                        amountSpent={item.valorCativo}
                                                        isPending={renderDeducaoStatusListByItem(item)}
                                                        onHide={() => setOpenMovementsInfoModal(false)}
                                                        seqCativo={item.seqCativo}
                                                        enabledBtn={item.estado}
                                                        cardNumberTitle={item.numCartao}
                                                    />
                                            </div>
                                        </div>
                                        {/* <div className='mainTitleDataBoxViewListDeduction'>
                                            <div className='txtFirstOptionsTitleListDeduction'>{item.estado}</div>
                                        </div> */}
                                        <div className='amountDiv'>
                                            <div className="textTitleRegularListDeductionWithSaldoMobile">{item.descritivo}</div>
                                        </div>
                                        <div className='rowDataBoxViewContainerListDeduction'>
                                            <div className='mainModalInfoStatusDataBoxViewListDeduction' style={{ background: renderDeducaoStatusListByItem(item)?.color }}>
                                                <div className='iconModalInfoStatusDataBoxListDeduction' style={{ color: renderDeducaoStatusListByItem(item)?.iconColor }} ><GoDotFill /></div>
                                                <div className='txtModalInfoStatusDataBoxListDeduction'>{renderDeducaoStatusListByItem(item)?.title}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
            { (listRespData?.length > 0 && numPage > 1) && (
                <>
                    {/* <div className='mainPaginationViewContainerDeduction'></div> */}
                    <div className='mainPaginationViewContainerDeduction'>
                        <ListPagination numPage={numPage} pageNumber={pageNumber} setPageSelected={setPageSelected}/>
                    </div>
                </>
            )}
        </>
    )
}

export default ListDeduction